import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import authController from '../../redux/api/tbAuthController';
import userController from '../../redux/api/tbUserController';
import telemetryController from '../../redux/api/tbTelemetryController';

export const initialState = {
  customerUsers: [],
  status: 'idle',
};

export const getDataCustomerUsers = createAsyncThunk(
  'dataCustomerUsers',
  async (data) => {
    const { token, customerId, pageSize, page } = data;
    const response = await userController.getCustomerUsers(
      token,
      customerId,
      pageSize,
      page
    );
    const result = await Promise.all(
      response.data.map(async (item) => {
        let permission = await telemetryController.getPermission(
          token,
          'USER',
          item.id.id
        );
        let allRoles;
        Object.values(permission).map((item) => {
          if (item['key'] === 'role') allRoles = item.value;
        });
        return {
          ...item,
          attributes: {
            role: allRoles,
          },
        };
      })
    );
    return result;
  }
);

export const saveUser = createAsyncThunk('saveUser', async (data) => {
  const { token, tenantId, customerId, name, email, password } = data;
  const user = {
    customerId: {
      id: customerId,
      entityType: 'CUSTOMER',
    },
    tenantId: {
      id: tenantId,
      entityType: 'TENANT',
    },
    authority: 'CUSTOMER_USER',
    firstName: name,
    email: email,
  };
  const response = await userController.saveUser(token, user);
  const responeActivateToken = await userController.getActivationLink(
    token,
    response.id.id
  );
  const activateToken = responeActivateToken
    .toString()
    .split('activateToken=')[1];
  const activateUser = await authController.activateUser(
    token,
    activateToken,
    password
  );

  return activateUser;
});

export const updateUser = createAsyncThunk('updateUser', async (data) => {
  const {
    token,
    userId,
    customerId,
    tenantId,
    name,
    email,
    config,
    mode,
    operation,
    power,
  } = data;
  let user = {
    firstName: name,
    email: email,
    authority: 'CUSTOMER_USER',
  };
  if (customerId) {
    user = {
      ...user,
      id: {
        id: userId,
        entityType: 'USER',
      },
      customerId: {
        id: customerId,
        entityType: 'CUSTOMER',
      },
      tenantId: {
        id: tenantId,
        entityType: 'TENANT',
      },
    };
  }
  const response = await userController.saveUser(token, user);
  const responseRole = await telemetryController.saveEntityAttributesV2(
    token,
    'USER',
    response.id.id,
    {
      role: { power: power, mode: mode, operation: operation, config: config },
    }
  );
  return responseRole;
});

export const deleteUser = createAsyncThunk('deleteUser', async (data) => {
  const { token, userId } = data;
  const response = await userController.deleteUser(token, userId);
  return response.data;
});

export const customerUsersSlice = createSlice({
  name: 'customerUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getCustomerUsers
    builder.addCase(getDataCustomerUsers.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getDataCustomerUsers.fulfilled, (state, action) => {
      state.status = 'idle';
      state.customerUsers = action.payload;
    });
    builder.addCase(getDataCustomerUsers.rejected, (state) => {
      state.status = 'failed';
      state.customerUsers = [];
    });
    // saveUser
    builder.addCase(saveUser.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(saveUser.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Successfully saved user information.');
    });
    builder.addCase(saveUser.rejected, (state) => {
      state.status = 'failed';
      toast.error('The name cannot be the same as the existing name.');
    });
    // updateUser
    builder.addCase(updateUser.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Successfully saved user information.');
    });
    builder.addCase(updateUser.rejected, (state) => {
      state.status = 'failed';
      toast.error('The name cannot be the same as the existing name.');
    });
    // deleteUser
    builder.addCase(deleteUser.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Deleted user successfully.');
    });
    builder.addCase(deleteUser.rejected, (state) => {
      state.status = 'failed';
      toast.error('Delete user failed.');
    });
  },
});

export default customerUsersSlice.reducer;

export const allCustomerUsers = (state) => state.customerUsers.customerUsers;
